export function asArrayResult(result) {
  if (Array.isArray(result)) {
    return result
  }
  if (Array.isArray(result?.data)) {
    return result.data
  }
  if (Array.isArray(result?.items)) {
    return result.items
  }
  if (Array.isArray(result?.list)) {
    return result.list
  }
  return []
}

export function asPageResult(result, fallbackPageSize = 10) {
  const data = asArrayResult(result)
  const total = Number(result?.total ?? result?.count ?? data.length)
  const page = Number(result?.page ?? result?.pageNo ?? 1)
  const pageSize = Number(result?.pageSize ?? result?.size ?? fallbackPageSize)

  return {
    data,
    total: Number.isFinite(total) ? total : data.length,
    page: Number.isFinite(page) && page > 0 ? page : 1,
    pageSize: Number.isFinite(pageSize) && pageSize > 0 ? pageSize : fallbackPageSize,
  }
}
